import { MuiBox, MuiTypography } from "../..";
import { BillingConfigurationDetailsHeaderWrapper } from "./BillingConfigurationDetailsHeader.style";

export const BillingConfigurationDetailsHeader: React.FC<{
  header: string;
  showBlueBackground?: boolean;
}> = ({ header, showBlueBackground = true }) => {
  return (
    <BillingConfigurationDetailsHeaderWrapper id={`header-${header}`}>
      <MuiBox
        className={
          showBlueBackground
            ? "header-label-container with-background"
            : "header-label-container"
        }
      >
        <MuiTypography
          variant="h2SemiBold"
          className="header-label"
          component={"h2"}
        >
          {header}
        </MuiTypography>
      </MuiBox>
    </BillingConfigurationDetailsHeaderWrapper>
  );
};
